export const exactForbidden = [
    "home", "about", "aboutus", "linkerto", "404", "setting", "settings",
    "documentation", "docs", "dashboard", "credentials", "passwordreset",
    "sendpasswordreset", "profile", "logout", "login", "signup",
    "termsandconditions", "privacypolicy", "linkertome", "linkertocom",
    "usersettings", "page", "create", "announcements", "contact", "contactus", "config"
  ];
  
export const partialForbiddenPattern = /(script|xxx|xvideos|xnxx|porn|linkerto)/i;